export const requestProgressState = {
  inProgress: true,
}

export const successProgressState = {
  inProgress: false,
  hasLoaded: true,
  hasError: false,
}

export const errorProgressState = {
  inProgress: false,
  hasLoaded: true,
  hasError: true,
  error: {}
}

export const initialProgressState = {
  inProgress: false,
  hasLoaded: false,
  hasError: false,
}



// WEBPACK FOOTER //
// ./src/utils/progress.js